namespace Areas.MyWorkflows {
    "use strict";

    const tabItems = Areas.createTabsWithSameController("MyWorkflows", ["Review", "Closed", "InProcess"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }

    function getDataGridName() : string {
        const url = window.location.href;
        if (url.indexOf("Review") > 0)
            return "ReviewWorkflowGrid";
        else if (url.indexOf("Closed") > 0)
            return "ClosedWorkFlowGrid"; 
    };

    const viewUrl = "/MyWorkflows/View/Index/";

    export function gotoView() {
        gotoSelected(getDataGridName(), viewUrl);
    }

    export function viewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowId; },
            `<a href= '${viewUrl}{placeholder}'>View</a>`);
    }

    const reviewUrl = "/MyWorkflows/Action/Index/";

    export function gotoReview() {
        gotoSelected(getDataGridName(), reviewUrl);
    }

    export function reviewLink(cellElement, cellInfo) {
        buildCellContent(cellElement, () => { return cellInfo.data.workflowDetailId; },
            `<a href= '${reviewUrl}{placeholder}'>Review</a>`);
    }

}